<section class="usp-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header text-center mb-5">
            <h2 class="section-title">{{ sectionTitle }}</h2>
            <div class="title-underline"></div>
        </div>

        <!-- USP Items Grid -->
        <div class="usp-grid">
            <div class="usp-item" *ngFor="let item of uspItems">
                <div class="icon-box">
                    <mat-icon class="usp-icon">{{ item.icon }}</mat-icon>
                    <div class="icon-bg"></div>
                </div>

                <div class="usp-content">
                    <h3 class="usp-title">{{ item.title }}</h3>
                    <p class="usp-description">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</section>